import { MultiSelect } from '@/components/helpers/MultiSelect';
import { TECH_STACK_CATALOGUE, type TechStack } from '@/utils/techStack';

export function TechStackHelper({
  value,
  onChange,
  locked = false
}: {
  value: TechStack;
  onChange: (next: TechStack) => void;
  locked?: boolean;
}): JSX.Element {
  return (
    <div>
      {locked && (
        <div className="stack-locked-note">
          <span className="lic">🔒</span>
          <span>
            The tech stack is locked after the first pipeline run and can no longer be edited.
          </span>
        </div>
      )}
      <div className={locked ? 'stack-locked' : ''}>
        <div className="stack-row2">
          <div className="stack-cat-label">Frontend</div>
          <MultiSelect
            label="Frontend"
            options={TECH_STACK_CATALOGUE.frontend}
            selected={value.frontend}
            disabled={locked}
            onChange={(next) => onChange({ ...value, frontend: next })}
          />
        </div>
        <div className="stack-row2">
          <div className="stack-cat-label">Backend</div>
          <MultiSelect
            label="Backend"
            options={TECH_STACK_CATALOGUE.backend}
            selected={value.backend}
            disabled={locked}
            onChange={(next) => onChange({ ...value, backend: next })}
          />
        </div>
        <div className="stack-row2">
          <div className="stack-cat-label">Database</div>
          <MultiSelect
            label="Database"
            options={TECH_STACK_CATALOGUE.database}
            selected={value.database}
            disabled={locked}
            onChange={(next) => onChange({ ...value, database: next })}
          />
        </div>
      </div>
    </div>
  );
}
